import React from "react";
import CommentList from "./comment-list";
import NearbyStore from "./nearby-stores";

export default function() {
  return (
    <div>
      <NearbyStore selectStore={this._selectStore} />
      <CommentList />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/stores/view.js